/*
 * WaWiBestandsbuchApp.tsx
 *
 * Created by Dr. Maximillian Dornseif 2021-11-28 in huWaWi3 24.5.4
 * Copyright (c) 2021, 2022 HUDORA GmbH
 */

import gql from 'graphql-tag'
import React from 'react'

import { BESTANDSBUCH_FRAGMENT } from '../fragments'
import { KindPage } from '../lib/components/KindPage'

export const IcBestandsbuchApp = (props) => {
  return (
    <KindPage
      basePath={'/ic'}
      componentPath={'bestandsbuch'}
      schemaName={'HwIcBestandsbuchEintrag'}
      title={'Bestandsbuch'}
      listQuery={BESTANDSBUCH_LIST_QUERY}
      entityQuery={BESTANDSBUCH_QUERY}
    ></KindPage>
  )
}
export const IcBestandsbuchUnverbuchtApp = (props) => {
  return (
    <KindPage
      basePath={'/ic'}
      componentPath={'unverbuchtesBestandsbuch'}
      schemaName={'HwIcBestandsbuchEintrag'}
      title={'Bestandsbuch unverbucht'}
      listQuery={BESTANDSBUCH_UNVERBUCHT_LIST_QUERY}
      entityQuery={BESTANDSBUCH_QUERY}
    ></KindPage>
  )
}

export const BESTANDSBUCH_LIST_QUERY = gql`
  query BestandsbuchList($cursor: String) {
    nodes: hwIcBestandsbuchEintragPages(after: $cursor) {
      edges {
        cursor
        node {
          ...bestandsbuchFragment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${BESTANDSBUCH_FRAGMENT}
`

export const BESTANDSBUCH_UNVERBUCHT_LIST_QUERY = gql`
  query BestandsbuchListUnverbucht($cursor: String) {
    nodes: hwIcBestandsbuchEintragPages(
      after: $cursor
      filter: { verbucht: { eq: false } }
      sort: { fields: [verbucht, datum, created_at], order: ASC }
    ) {
      edges {
        cursor
        node {
          ...bestandsbuchFragment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${BESTANDSBUCH_FRAGMENT}
`

const BESTANDSBUCH_QUERY = gql`
  query BestandsbuchEintrag($nr: ID!) {
    entity: hwIcBestandsbuchEintrag(designator: $nr) {
      ...bestandsbuchFragment
    }
  }
  ${BESTANDSBUCH_FRAGMENT}
`
